import { render, staticRenderFns } from "./ContactoDataRegister.vue?vue&type=template&id=235b7142"
import script from "./ContactoDataRegister.vue?vue&type=script&lang=js"
export * from "./ContactoDataRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports